import React, { useEffect, useRef } from 'react';
import { IOfferAnswerSetting, IOfferCrit, ITableDemandItem } from '@models/winnerSelection/ITableDemand';
import OfferCritDetails from '../../WinnerSelection/OfferCritDetails';
import { supplierOffersHint } from '../utils/dialogForm';
import type { IOfferCritDetailsFormData } from '../../WinnerSelection/OfferCritDetails/IOfferCritDetailsFormData';
import type { IOfferCritDetailsHandle } from '../../WinnerSelection/OfferCritDetails/OfferCritDetails';

interface IProps {
    tableKey: string;
    requestKey: string;
    participantKey: string;
    item: ITableDemandItem;
    value: IOfferCrit;
    disabledHint?: string;
    ratingScaleHints?: Record<string, string> | null;
    customScaleCrits?: string[] | null;
    editButtonName?: string | null;
    offerAnswerSettings?: IOfferAnswerSetting[] | null;
    showAnswerInScore?: boolean;
    showComment?: boolean;
    contextHint?: string;
    /** Сколько ещё предложений поставщика можно заполнить тем же ответом; 0 — без отметки. */
    otherSupplierOffers?: number;
    onSaved: () => void;
    saveAction: (value: IOfferCritDetailsFormData) => Promise<void>;
}

/**
 * Переиспользуем редактор критериев; запись выполняет защищённая команда матрицы.
 * Форма открывается сразу при монтировании.
 */
const CriterionEditor: React.FC<IProps> = ({
    tableKey,
    requestKey,
    participantKey,
    item,
    value,
    otherSupplierOffers = 0,
    onSaved,
    saveAction,
    ...settings
}) => {
    const ref = useRef<IOfferCritDetailsHandle>(null);
    useEffect(() => {
        ref.current?.open();
    }, []);

    return (
        <div className="ws2-criteria__editor">
            <OfferCritDetails
                ref={ref}
                tableKey={tableKey}
                isEdit={value.allowEdit}
                demandId={requestKey}
                offerId={participantKey}
                value={value}
                rowData={item}
                onSubmit={onSaved}
                saveAction={saveAction}
                preserveDraftOnUpdate
                allowGroupActions={otherSupplierOffers > 0}
                allowLotGroupAction={false}
                supplierGroupLabel="Применить ко всем предложениям поставщика"
                supplierGroupDescription={supplierOffersHint(otherSupplierOffers)}
                {...settings}
            />
        </div>
    );
};

export default CriterionEditor;
